import Vue from 'vue';
import {
    ValidationProvider,
    ValidationObserver,
    extend,
    localize
} from 'vee-validate';

// load the rules that will be used
import {
    required,
    min,
    min_value,
    max,
    max_value,
    confirmed,
    email,
    numeric,
    image,
    size,
} from 'vee-validate/dist/rules';

extend('confirmed', confirmed);
extend('email', email);
extend('max', max);
extend('max_value', max_value);
extend('min', min);
extend('min_value', min_value);
extend('required', required);
extend('numeric', numeric);
extend('image', image);
extend('size', size);

// load locales
import en from 'vee-validate/dist/locale/en';

localize({
    en,
});

// register vue component
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
